<template>
	<FormDropdown
		ref="ref_formdropdown"
		label="Filtros"
	>
		<DropdownCheckboxFk
			empty-label="Selecione as fazendas"
			:label="$t('farm')"
			:dropdown-options="fazendas"
			:ignore-properties="['id']"
			:value="filtros.fazendas"
		/>
		<DatePickerRange
			v-model="filtros.dataDePlantio"
			:label="$t('plantationDate')"
		/>
		<DatePickerRange
			v-model="filtros.dataDaUltimaMedicao"
			:label="$t('lastMeasurementDate')"
			style="margin-bottom: 1rem"
		/>
		<DropdownCheckboxFk
			:empty-label="$t('selectGeneticMaterialType')"
			:label="$t('geneticMaterial')"
			:dropdown-options="materiaisGeneticos"
			:ignore-properties="['id']"
			:value="filtros.materiaisGeneticos"
			style="margin-bottom: 1rem; margin-top: 1rem"
		/>
		<DropdownCheckboxFk
			:empty-label="$t('selectLastServiceOrderType')"
			:label="$t('lastServiceOrderType')"
			:dropdown-options="tiposDeOrdemDeServico"
			:ignore-properties="['id']"
			:value="filtros.tiposDaUltimaOrdemDeServico"
			style="margin-bottom: 1rem"
		/>

		<div class="container__filtros__planejamentocronograma__botoes">
			<Button
				:label="$t('clearFilters')"
				color="trv-default"
				semantic-class="mini"
				outlined
				@click="limparFiltros"
			/>
			<Button
				:label="$t('filter')"
				color="trv-default"
				semantic-class="mini"
				@click="aplicarFiltro"
			/>
		</div>
	</FormDropdown>
</template>

<script>
import { getDropdownFazendas } from '../../../../../services/requests/FazendaRequests'
import { getDropdownMateriaisGeneticos } from '../../../../../services/requests/MaterialGeneticoRequests'

import { tipoDeOrdemDeServicoComDescricao } from '../../../../../constants/Mappings/TiposDeOrdensDeServico'

import Button from '../../../../../components/Button/Button'
import DatePickerRange from '../../../../../components/DatePickerRange/DatePickerRange'
import DropdownCheckboxFk from '../../../../../components/DropdownCheckboxFk/DropdownCheckboxFk'
import FormDropdown from '../../../../../components/FormDropdown/FormDropdown'

export default {
	components: {
		Button,
		DatePickerRange,
		DropdownCheckboxFk,
		FormDropdown,
	},
	props: {
		filtrosSalvosNoBanco: {
			type: Object,
		},
	},
	data() {
		return {
			filtros: {
				fazendas: [],
				materiaisGeneticos: [],
				tiposDaUltimaOrdemDeServico: [],
				dataDePlantio: { start: undefined, end: undefined },
				dataDaUltimaMedicao: { start: undefined, end: undefined },
			},
			fazendas: [],
			materiaisGeneticos: [],
		}
	},
	computed: {
		tiposDeOrdemDeServico() {
			return tipoDeOrdemDeServicoComDescricao.map((tipoDeOrdemDeServico) => {
				return {
					id: tipoDeOrdemDeServico.codigo,
					[this.$t('description')]: tipoDeOrdemDeServico.descricao,
					[this.$t('name')]: tipoDeOrdemDeServico.abreviacao,
				}
			})
		},
		buscouTodasAsFazendasEMateriaisGeneticos() {
			return this.fazendas.length > 0 && this.materiaisGeneticos.length > 0
		},
	},
	created() {
		this.buscarOpcoesDeFazendasParaDropdown()
		this.buscarOpcoesDeMateriaisGeneticosParaDropdown()
		if (this.filtrosSalvosNoBanco) this.configurarFiltrosDeDatasSalvosNoBanco()
	},
	methods: {
		buscarOpcoesDeFazendasParaDropdown() {
			getDropdownFazendas().then((response) => {
				this.fazendas = response
				this.configurarFiltrosDeFazendasSalvosNoBanco()
				this.carregarTagsComOsFiltrosUsados()
			})
		},
		buscarOpcoesDeMateriaisGeneticosParaDropdown() {
			getDropdownMateriaisGeneticos().then((response) => {
				this.materiaisGeneticos = response
				this.configurarFiltrosDeMateriaisGeneticosSalvosNoBanco()
				this.carregarTagsComOsFiltrosUsados()
			})
		},
		recuperarFiltro() {
			const fazendasSelecionadas = this.fazendas.filter((fazenda) =>
				this.filtros.fazendas.includes(fazenda.id),
			)
			const materiaisGeneticosSelecionados = this.materiaisGeneticos.filter((materialGenetico) =>
				this.filtros.materiaisGeneticos.includes(materialGenetico.id),
			)
			const tiposDeOrdensDeServicosSelecionados = tipoDeOrdemDeServicoComDescricao.filter(
				(tipoDeOrdemDeServico) =>
					this.filtros.tiposDaUltimaOrdemDeServico.includes(tipoDeOrdemDeServico.codigo),
			)
			const dataDePlantio = this.filtros.dataDePlantio
			const dataDaUltimaMedicao = this.filtros.dataDaUltimaMedicao

			return {
				fazendasSelecionadas,
				materiaisGeneticosSelecionados,
				tiposDeOrdensDeServicosSelecionados,
				dataDePlantio,
				dataDaUltimaMedicao,
			}
		},
		aplicarFiltro() {
			this.$refs.ref_formdropdown.fecharFormDropdown()
			this.$emit('aplicaFiltros', this.recuperarFiltro())
		},
		limparFiltros() {
			this.filtros = {
				fazendas: [],
				materiaisGeneticos: [],
				tiposDaUltimaOrdemDeServico: [],
				dataDePlantio: {},
				dataDaUltimaMedicao: {},
			}
		},
		configurarFiltrosDeDatasSalvosNoBanco() {
			this.filtros.dataDePlantio = this.filtrosSalvosNoBanco.dataDePlantio
			this.filtros.dataDaUltimaMedicao = this.filtrosSalvosNoBanco.dataDaUltimaMedicao
			this.carregarTagsComOsFiltrosUsados()
		},
		configurarFiltrosDeFazendasSalvosNoBanco() {
			if (this.filtrosSalvosNoBanco)
				this.filtros.fazendas = this.filtrosSalvosNoBanco.fazendasSelecionadas
		},
		configurarFiltrosDeMateriaisGeneticosSalvosNoBanco() {
			if (this.filtrosSalvosNoBanco)
				this.filtros.materiaisGeneticos = this.filtrosSalvosNoBanco.materiaisGeneticosSelecionados
		},
		carregarTagsComOsFiltrosUsados() {
			this.$emit('carregouFiltrosSalvosDoBanco', this.recuperarFiltro())
		},
	},
}
</script>

<style scoped>
.container__filtros__planejamentocronograma__botoes {
	display: flex;
}
</style>
